<span #animatedDigit class="animated-digit">    
</span>